/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ stage: NonNullable<unknown> }} Dashboard_Task_StageInputs */

const en_dashboard_task_stage = /** @type {(inputs: Dashboard_Task_StageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.stage} Stage`)
};

const pt_br2_dashboard_task_stage = /** @type {(inputs: Dashboard_Task_StageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Etapa ${i?.stage}`)
};

/**
* | output |
* | --- |
* | "{stage} Stage" |
*
* @param {Dashboard_Task_StageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_task_stage = /** @type {((inputs: Dashboard_Task_StageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Task_StageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_task_stage(inputs)
	return pt_br2_dashboard_task_stage(inputs)
});